import { Component, inject } from '@angular/core';
import { NgLabelTemplateDirective, NgOptionComponent, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { UserProfileService } from '../../services/API/user-profile.service/user-profile.service';
import { CardDetails } from '../../models/interfaces/response';
import { CurrencyPipe, JsonPipe, NgFor, NgIf, TitleCasePipe } from '@angular/common';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { FormsModule } from '@angular/forms';
import { PopupService } from '../../services/popup/popup.service';

@Component({
  selector: 'app-payment-confirmation',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    FormsModule,
    TitleCasePipe,
    CurrencyPipe,

    NgSelectComponent,
    NgOptionTemplateDirective,
    NgLabelTemplateDirective,

    ButtonComponent,
  ],
  templateUrl: './payment-confirmation.component.html',
  styleUrl: './payment-confirmation.component.scss'
})
export class PaymentConfirmationComponent {
  userProfileService = inject(UserProfileService);
  popupService = inject(PopupService);
  isLoading = false;
  isEmpty = false;

  cardList: Array<CardDetails> = [];
  selectedCard: CardDetails | null = null;
  selectedID: CardDetails["paymentMethodId"] | null = '';
  cardMap = new Map<string, CardDetails>();

  data = {
    totalPayable: 0,
  }
  ngOnInit(): void {
    this.getCards();
  }

  getCards(): void {
    this.isLoading = true;
    this.userProfileService.getSavedCards()
      .subscribe({
        next: (res) => {
          const data = [...res.data];
          this.isEmpty = !data.length;
          this.cardList = data.map(el => {
            return {
              ...el,
              expMonth: el.expMonth.toString().padStart(2, "0"),
            }
          });
          this.cardList.map(el => {
            if (el.paymentMethodId)
            this.cardMap.set(el.paymentMethodId, el);
          })
          this.cardList.unshift({
            paymentMethodId: '',
            brand: 'none',
            expMonth: '00',
            expYear: 0 ,
            last4: '0000',
            selected: false,
          });
          this.selectedCard = this.cardList.find(el => el.selected) || null;
          if (this.selectedCard) {
              this.selectedID = this.selectedCard.paymentMethodId;
          }
          else {
            this.selectedID = '';
          }

        },
        complete: () => {
          this.isLoading = false;
        },
      })
  }


  pay(): void {
    this.popupService.emitAction({
      action: 'close',
      payload: {
        paymentMethodId: this.selectedID, }
      })
  }

  payWithoutCard(): void {
    this.popupService.emitAction({
      action: 'close',
      payload: {
        paymentMethodId: null }
      })
  }
  close(): void {
    this.popupService.close();
  }
}
